<div class="forbidden__container">
  <div class="forbidden__content">
    <div class="forbidden__icon-lock">
      <i class="fas fa-lock"></i>
    </div>
    <h2>Acesso negado</h2>
    <p>
      Você não tem permissão para acessar esta página.<br />
      Se acredita que isso é um erro, entre em contato com o administrador.
    </p>
    <button class="btn btn-primary rounded-0" (click)="goToHome()">Voltar para o início</button>
  </div>
</div>
